var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "other-info"
  }, [_c('b-alert', {
    staticClass: "text-center font-weight-bold m-3",
    attrs: {
      "show": !_vm.uhvCards.length && !_vm.etcCards.length && !_vm.loading,
      "variant": "secondary"
    }
  }, [_vm._v(" 目前暫無資料 ")]), _vm.uhvCards.length ? _c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("特高壓電表")]), _c('span', {
    staticClass: "section-time"
  }, [_vm._v("更新於 " + _vm._s(_vm.uhvTime))]), _c('button', {
    staticClass: "refresh-icon",
    attrs: {
      "type": "button",
      "title": "更新全部電表",
      "aria-label": "更新全部電表",
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.refreshAll();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  })])]), _c('div', {
    staticClass: "card-grid"
  }, _vm._l(_vm.uhvCards, function (card) {
    return _c('div', {
      key: card.title,
      staticClass: "info-card"
    }, [_c('div', {
      staticClass: "info-card-head"
    }, [_c('span', [_vm._v(_vm._s(card.title))]), _c('span', {
      staticClass: "head-value"
    }, [_vm._v(_vm._s(card.headline))])]), _vm._l(card.rows, function (row) {
      return _c('div', {
        key: row.label,
        staticClass: "info-row"
      }, [_c('span', {
        staticClass: "info-label"
      }, [_vm._v(_vm._s(row.label))]), _c('span', {
        staticClass: "info-value"
      }, [_vm._v(_vm._s(row.value))])]);
    })], 2);
  }), 0)]) : _vm._e(), _vm.etcCards.length ? _c('section', [_c('div', {
    staticClass: "section-head"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("其他設備")]), !_vm.uhvCards.length ? _c('button', {
    staticClass: "refresh-icon",
    attrs: {
      "type": "button",
      "title": "更新全部電表",
      "aria-label": "更新全部電表",
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.refreshAll();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "card-grid"
  }, _vm._l(_vm.etcCards, function (card) {
    return _c('div', {
      key: card.title,
      staticClass: "info-card"
    }, [_c('div', {
      staticClass: "info-card-head"
    }, [_vm._v(_vm._s(card.title))]), _vm._l(card.rows, function (row) {
      return _c('div', {
        key: row.label,
        staticClass: "info-row"
      }, [_c('span', {
        staticClass: "info-label"
      }, [_vm._v(_vm._s(row.label))]), _c('span', {
        staticClass: "info-value"
      }, [_vm._v(_vm._s(row.value))])]);
    })], 2);
  }), 0)]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };